import React from 'react';

import { Select } from 'antd';

export default function CmbLingua(props: any) {
    const onSelectChange = (e: string) => {
        localStorage.setItem('codLingua', e);

        window.location.reload();
    };

    return (
        <div onClick={(e) => e.stopPropagation()}>
            <Select
                bordered={false}
                popupMatchSelectWidth={false}
                defaultValue={localStorage.getItem('codLingua') ? localStorage.getItem('codLingua') : 'it'}
                className="my-select"
                style={{ width: props.width }}
                onSelect={onSelectChange}
                size="middle"
            >
                <Select.Option value="en">English</Select.Option>
                <Select.Option value="it">Italiano</Select.Option>
                {/* <Select.Option value="fr">Français</Select.Option> */}
            </Select>
        </div>
    );
}
